"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ClassUtil_1 = require("../util/ClassUtil");
var DerivedSecrets_1 = require("../derived/DerivedSecrets");
var MacKey_1 = require("../derived/MacKey");
var MessageKeys_1 = require("./MessageKeys");
var ChainKey = (function () {
    function ChainKey() {
        this.idx = -1;
        this.key = new MacKey_1.default(new Uint8Array([]));
    }
    ChainKey.from_mac_key = function (key, counter) {
        var ck = ClassUtil_1.default.new_instance(ChainKey);
        ck.key = key;
        ck.idx = counter;
        return ck;
    };
    ChainKey.prototype.next = function () {
        var ck = ClassUtil_1.default.new_instance(ChainKey);
        ck.key = new MacKey_1.default(this.key.sign('1'));
        ck.idx = this.idx + 1;
        return ck;
    };
    ChainKey.prototype.message_keys = function () {
        var base = this.key.sign('0');
        var derived_secrets = DerivedSecrets_1.default.kdf_without_salt(base, 'hash_ratchet');
        return MessageKeys_1.default.new(derived_secrets.cipher_key, derived_secrets.mac_key, this.idx);
    };
    ChainKey.prototype.encode = function (encoder) {
        encoder.object(2);
        encoder.u8(0);
        this.key.encode(encoder);
        encoder.u8(1);
        return encoder.u32(this.idx);
    };
    ChainKey.decode = function (decoder) {
        var self = ClassUtil_1.default.new_instance(ChainKey);
        var nprops = decoder.object();
        for (var index = 0; index <= nprops - 1; index++) {
            switch (decoder.u8()) {
                case 0:
                    self.key = MacKey_1.default.decode(decoder);
                    break;
                case 1:
                    self.idx = decoder.u32();
                    break;
                default:
                    decoder.skip();
            }
        }
        return self;
    };
    return ChainKey;
}());
exports.default = ChainKey;
//# sourceMappingURL=ChainKey.js.map


//////////////////
// WEBPACK FOOTER
// ../proteus/dist/session/ChainKey.js
// module id = 28
// module chunks = 0 1